export function formatToNorwegianPrice(price: number) {
  return Intl.NumberFormat('nb-NO').format(price);
}
export const fixToPositiveIntegerString = (input: string): string => {
  if (input === '') return '';
  return Math.floor(Math.abs(Number(input))).toString();
};
